import { CUSTOMER_SIDEBAR_ITEMS } from "../customer/customerConfig";
import { CAREGIVER_SIDEBAR_ITEMS, CAREGIVER_USER_META } from "../caregiver/caregiverConfig";
import {
  CARE_MANAGER_SIDEBAR_ITEMS,
  CARE_MANAGER_USER_META,
} from "../caremanager/careManagerConfig";

import { ADMIN_MODULE_NAV } from "../../config/adminSopConfig";

export const ROLE_SIDEBAR_CONFIG = {
  ops: {
    ariaLabel: "Operations navigation",
    user: { initials: "OP", name: "Ops Admin", role: "NEMA Operations" },
    items: ADMIN_MODULE_NAV,
  },
  customer: {
    ariaLabel: "Customer navigation",
    user: { initials: "", name: "", role: "Customer account" },
    items: CUSTOMER_SIDEBAR_ITEMS,
  },
  caregiver: {
    ariaLabel: "Caregiver navigation",
    user: CAREGIVER_USER_META,
    items: CAREGIVER_SIDEBAR_ITEMS,
  },
  careManager: {
    ariaLabel: "Care manager navigation",
    user: CARE_MANAGER_USER_META,
    items: CARE_MANAGER_SIDEBAR_ITEMS,
  },
};
